module.exports = __webpack_public_path__ + "img/2.9f395e75.jpg";